import PageSectionTextEditable from './sections/tab_edit/section_text';
import PageSectionBlockEditable from './sections/tab_edit/section_block';
import PageSectionMapEditable from './sections/tab_edit/section_map';
import PageSectionFormEditable from './sections/tab_edit/section_form';
import PageSectionTripFormatsEditable from './sections/tab_edit/section_trip_formats';
import PageSectionProductsListEditable from './sections/tab_edit/section_product_snippets';
import PageSectionPricesEditable from './sections/tab_edit/section_prices';
import PageSectionReviewsEditable from './sections/tab_edit/section_reviews';
import PageSectionTeamMembersEditable from './sections/tab_edit/section_team';
import PageSectionStaffProfilesEditable from './sections/tab_edit/section_staff_profiles';
import PageSectionInternalLinksEditable from './sections/tab_edit/section_internal_links';
import PageSectionRecentlyViewedEditable from './sections/tab_edit/section_recently_viewed';
import PageSectionProjectOverviewEditable from './sections/tab_edit/section_project_overview';
import PageSectionProductPartnersEditable from './sections/tab_edit/section_partners';
import PageSectionProductItineraryEditable from './sections/tab_edit/section_itinerary';
import PageSectionSharingEditable from './sections/tab_edit/section_sharing';
import PageSectionAuthorEditable from './sections/tab_edit/section_author';
import PageSectionLinkToEditable from './sections/tab_edit/section_link_to';
import PageSectionCallToActionEditable from './sections/tab_edit/section_call_to_action';
import PageSectionNextStepsEditable from './sections/tab_edit/section_next_steps';
import PageSectionReviewSnippetsEditable from './sections/tab_edit/section_review_snippets';
import PageSectionFaqsEditable from './sections/tab_edit/section_faqs';
import PageSectionSearchResultsEditable from './sections/tab_edit/section_search_results';
import PageSectionFindYourProjectEditable from './sections/tab_edit/section_find_your_project';
import PageSectionLargeSnippetsEditable from './sections/tab_edit/section_large_snippets';
import PageSectionValuePropositionEditable from './sections/tab_edit/section_value_proposition';
import PageSectionGroupTripsBannerEditable from './sections/tab_edit/section_group_trips_banner';
import PageSectionMeetUsEditable from './sections/tab_edit/section_meet_us';
import PageSectionTripFormatsCarouselEditable from './sections/tab_edit/section_trip_formats_carousel';
import PageSectionBlogSnippetsEditable from './sections/tab_edit/section_blog_snippets';
import PageSectionEventsEditable from './sections/tab_edit/section_events';
import PageSectionPromotionalBoxesEditable from './sections/tab_edit/section_promotional_boxes';
import PageSectionTextColumnsSingleMediaEditable from './sections/tab_edit/section_text_columns_single_media';
import PageSectionTextColumnsMultipleMediaEditable from './sections/tab_edit/section_text_columns_multiple_media';

import PageSectionText from './sections/tab_dnd/section_text';
import PageSectionBlock from './sections/tab_dnd/section_block';
import PageSectionMap from './sections/tab_dnd/section_map';
import PageSectionForm from './sections/tab_dnd/section_form';
import PageSectionProductsList from './sections/tab_dnd/section_product_snippets';
import PageSectionTripFormats from './sections/tab_dnd/section_trip_formats';
import PageSectionPrices from './sections/tab_dnd/section_prices';
import PageSectionReviews from './sections/tab_dnd/section_reviews';
import PageSectionTeamMembers from './sections/tab_dnd/section_team';
import PageSectionStaffProfiles from './sections/tab_dnd/section_staff_profiles';
import PageSectionInternalLinks from './sections/tab_dnd/section_internal_links';
import PageSectionRecentlyViewed from './sections/tab_dnd/section_recently_viewed';
import PageSectionProjectOverview from './sections/tab_dnd/section_project_overview';
import PageSectionProductPartners from './sections/tab_dnd/section_partners';
import PageSectionProductItinerary from './sections/tab_dnd/section_itinerary';
import PageSectionCallToAction from './sections/tab_dnd/section_call_to_action';
import PageSectionAuthor from './sections/tab_dnd/section_author';
import PageSectionSharing from './sections/tab_dnd/section_sharing';
import PageSectionLinkTo from './sections/tab_dnd/section_link_to';
import PageSectionNextSteps from './sections/tab_dnd/section_next_steps';
import PageSectionReviewSnippets from './sections/tab_dnd/section_review_snippets';
import PageSectionFaqs from './sections/tab_dnd/section_faqs';
import PageSectionSearchResults from './sections/tab_dnd/section_search_results';
import PageSectionBlogSnippets from './sections/tab_dnd/section_blog_snippets';
import PageSectionFindYourProject from './sections/tab_dnd/section_find_your_project';
import PageSectionLargeSnippets from './sections/tab_dnd/section_large_snippets';
import PageSectionValueProposition from './sections/tab_dnd/section_value_proposition';
import PageSectionGroupTripsBanner from './sections/tab_dnd/section_group_trips_banner';
import PageSectionMeetUs from './sections/tab_dnd/section_meet_us';
import PageSectionTripFormatsCarousel from './sections/tab_dnd/section_trip_formats_carousel';
import PageSectionEvents from './sections/tab_dnd/section_events';
import PageSectionPromotionalBoxes from './sections/tab_dnd/section_promotional_boxes';
import PageSectionTextColumnsSingleMedia from './sections/tab_dnd/section_text_columns_single_media';
import PageSectionTextColumnsMultipleMedia from './sections/tab_dnd/section_text_columns_multiple_media';

export const SECTION_TYPE_TEXT = 1;
export const SECTION_TYPE_BLOCK = 2;
export const SECTION_TYPE_MAP = 3;
export const SECTION_TYPE_PRICE = 4;
export const SECTION_TYPE_FORM = 5;
export const SECTION_TYPE_REVIEWS = 7;
export const SECTION_TYPE_STAFF = 8;
export const SECTION_TYPE_INTERNAL_LINK_SNIPPET = 9;
export const SECTION_TYPE_PRODUCT_SNIPPET = 10;
export const SECTION_TYPE_TRIP_FORMAT_SNIPPET = 11;
export const SECTION_TYPE_CALL_TO_ACTION = 12;
export const SECTION_TYPE_ITINERARY = 13;
export const SECTION_TYPE_PARTNERS = 14;
export const SECTION_TYPE_OVERVIEW = 15;
export const SECTION_TYPE_RECENTLY_VIEWED = 16;
export const SECTION_TYPE_NEXT_STEPS = 17;
export const SECTION_TYPE_REVIEW_SNIPPETS = 18;
export const SECTION_TYPE_FAQS = 20;
export const SECTION_TYPE_STAFF_PROFILES = 21;
export const SECTION_TYPE_SEARCH_RESULTS = 22;
export const SECTION_TYPE_FIND_YOUR_PROJECT = 23;
export const SECTION_TYPE_LARGE_SNIPPETS = 24;
export const SECTION_TYPE_VALUE_PROPOSITION = 25;
export const SECTION_TYPE_GROUP_TRIPS_BANNER = 26;
export const SECTION_TYPE_MEET_US = 27;
export const SECTION_TYPE_TRIP_FORMATS_CAROUSEL = 28;
export const SECTION_TYPE_SHARING = 30;
export const SECTION_TYPE_AUTHOR = 31;
export const SECTION_TYPE_LINK_TO = 32;
export const SECTION_TYPE_BLOG_SNIPPETS = 33;
export const SECTION_TYPE_EVENTS = 29;
export const SECTION_TYPE_PROMOTIONAL_BOXES = 34;
export const SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA = 35;
export const SECTION_TYPE_TEXT_COLUMNS_MULTIPLE_MEDIA = 36;

export const PAGE_TYPE_DESTINATION = 'DESTINATION';
export const PAGE_TYPE_CONTINENT = 'CONTINENT';
export const PAGE_TYPE_BLOG_POST = 'BLOG_POST';
export const PAGE_TYPE_PRODUCT = 'PRODUCT';
export const PAGE_TYPE_PRODUCT_FIXED_DATES = 'PRODUCT_FIXED_DATES';
export const PAGE_TYPE_REVIEW = 'REVIEW';
export const PAGE_TYPE_STAFF_TEAM = 'STAFF_TEAM';
export const PAGE_TYPE_LANDING = 'LANDING';

export const sections = {
    [SECTION_TYPE_TEXT]: PageSectionText,
    [SECTION_TYPE_BLOCK]: PageSectionBlock,
    [SECTION_TYPE_MAP]: PageSectionMap,
    [SECTION_TYPE_PRICE]: PageSectionPrices,
    [SECTION_TYPE_FORM]: PageSectionForm,
    [SECTION_TYPE_TRIP_FORMAT_SNIPPET]: PageSectionTripFormats,
    [SECTION_TYPE_PRODUCT_SNIPPET]: PageSectionProductsList,
    [SECTION_TYPE_REVIEWS]: PageSectionReviews,
    [SECTION_TYPE_STAFF]: PageSectionTeamMembers,
    [SECTION_TYPE_STAFF_PROFILES]: PageSectionStaffProfiles,
    [SECTION_TYPE_INTERNAL_LINK_SNIPPET]: PageSectionInternalLinks,
    [SECTION_TYPE_STAFF]: PageSectionTeamMembers,
    [SECTION_TYPE_RECENTLY_VIEWED]: PageSectionRecentlyViewed,
    [SECTION_TYPE_OVERVIEW]: PageSectionProjectOverview,
    [SECTION_TYPE_PARTNERS]: PageSectionProductPartners,
    [SECTION_TYPE_ITINERARY]: PageSectionProductItinerary,
    [SECTION_TYPE_CALL_TO_ACTION]: PageSectionCallToAction,
    [SECTION_TYPE_SHARING]: PageSectionSharing,
    [SECTION_TYPE_AUTHOR]: PageSectionAuthor,
    [SECTION_TYPE_LINK_TO]: PageSectionLinkTo,
    [SECTION_TYPE_NEXT_STEPS]: PageSectionNextSteps,
    [SECTION_TYPE_REVIEW_SNIPPETS]: PageSectionReviewSnippets,
    [SECTION_TYPE_FAQS]: PageSectionFaqs,
    [SECTION_TYPE_SEARCH_RESULTS]: PageSectionSearchResults,
    [SECTION_TYPE_FIND_YOUR_PROJECT]: PageSectionFindYourProject,
    [SECTION_TYPE_LARGE_SNIPPETS]: PageSectionLargeSnippets,
    [SECTION_TYPE_VALUE_PROPOSITION]: PageSectionValueProposition,
    [SECTION_TYPE_GROUP_TRIPS_BANNER]: PageSectionGroupTripsBanner,
    [SECTION_TYPE_MEET_US]: PageSectionMeetUs,
    [SECTION_TYPE_TRIP_FORMATS_CAROUSEL]: PageSectionTripFormatsCarousel,
    [SECTION_TYPE_BLOG_SNIPPETS]: PageSectionBlogSnippets,
    [SECTION_TYPE_EVENTS]: PageSectionEvents,
    [SECTION_TYPE_PROMOTIONAL_BOXES]: PageSectionPromotionalBoxes,
    [SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA]: PageSectionTextColumnsSingleMedia,
    [SECTION_TYPE_TEXT_COLUMNS_MULTIPLE_MEDIA]: PageSectionTextColumnsMultipleMedia,
};

export const sectionsEditable = {
    [SECTION_TYPE_TEXT]: PageSectionTextEditable,
    [SECTION_TYPE_BLOCK]: PageSectionBlockEditable,
    [SECTION_TYPE_MAP]: PageSectionMapEditable,
    [SECTION_TYPE_PRICE]: PageSectionPricesEditable,
    [SECTION_TYPE_FORM]: PageSectionFormEditable,
    [SECTION_TYPE_TRIP_FORMAT_SNIPPET]: PageSectionTripFormatsEditable,
    [SECTION_TYPE_PRODUCT_SNIPPET]: PageSectionProductsListEditable,
    [SECTION_TYPE_REVIEWS]: PageSectionReviewsEditable,
    [SECTION_TYPE_STAFF]: PageSectionTeamMembersEditable,
    [SECTION_TYPE_INTERNAL_LINK_SNIPPET]: PageSectionInternalLinksEditable,
    [SECTION_TYPE_STAFF_PROFILES]: PageSectionTeamMembersEditable,
    [SECTION_TYPE_STAFF_PROFILES]: PageSectionStaffProfilesEditable,
    [SECTION_TYPE_STAFF]: PageSectionTeamMembersEditable,
    [SECTION_TYPE_RECENTLY_VIEWED]: PageSectionRecentlyViewedEditable,
    [SECTION_TYPE_OVERVIEW]: PageSectionProjectOverviewEditable,
    [SECTION_TYPE_PARTNERS]: PageSectionProductPartnersEditable,
    [SECTION_TYPE_ITINERARY]: PageSectionProductItineraryEditable,
    [SECTION_TYPE_CALL_TO_ACTION]: PageSectionCallToActionEditable,
    [SECTION_TYPE_SHARING]: PageSectionSharingEditable,
    [SECTION_TYPE_AUTHOR]: PageSectionAuthorEditable,
    [SECTION_TYPE_LINK_TO]: PageSectionLinkToEditable,
    [SECTION_TYPE_NEXT_STEPS]: PageSectionNextStepsEditable,
    [SECTION_TYPE_REVIEW_SNIPPETS]: PageSectionReviewSnippetsEditable,
    [SECTION_TYPE_FAQS]: PageSectionFaqsEditable,
    [SECTION_TYPE_SEARCH_RESULTS]: PageSectionSearchResultsEditable,
    [SECTION_TYPE_FIND_YOUR_PROJECT]: PageSectionFindYourProjectEditable,
    [SECTION_TYPE_LARGE_SNIPPETS]: PageSectionLargeSnippetsEditable,
    [SECTION_TYPE_VALUE_PROPOSITION]: PageSectionValuePropositionEditable,
    [SECTION_TYPE_GROUP_TRIPS_BANNER]: PageSectionGroupTripsBannerEditable,
    [SECTION_TYPE_MEET_US]: PageSectionMeetUsEditable,
    [SECTION_TYPE_TRIP_FORMATS_CAROUSEL]: PageSectionTripFormatsCarouselEditable,
    [SECTION_TYPE_BLOG_SNIPPETS]: PageSectionBlogSnippetsEditable,
    [SECTION_TYPE_EVENTS]: PageSectionEventsEditable,
    [SECTION_TYPE_PROMOTIONAL_BOXES]: PageSectionPromotionalBoxesEditable,
    [SECTION_TYPE_TEXT_COLUMNS_SINGLE_MEDIA]: PageSectionTextColumnsSingleMediaEditable,
    [SECTION_TYPE_TEXT_COLUMNS_MULTIPLE_MEDIA]: PageSectionTextColumnsMultipleMediaEditable,
};



// WEBPACK FOOTER //
// ./src/containers/builder/constants.js